import { atom } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import type { PropsWithChildren, ReactNode } from 'react';

// Indicate the number of times the form has been validated
export const formValidatedAtom = atom<number>(0);
formValidatedAtom.debugLabel = 'formValidatedAtom';

export const formDisabledReasonAtom = atom<string>('');
formDisabledReasonAtom.debugLabel = 'formDisabledReasonAtom';

export function FormAtomsProvider({ children }: PropsWithChildren): ReactNode {
	return <ScopeProvider atoms={[formValidatedAtom, formDisabledReasonAtom]}>{children}</ScopeProvider>;
}
